// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"GroupTabs_tabsContainer__3urRI","tabs":"GroupTabs_tabs__3UqUI"};